export default __webpack_public_path__ + "2949e62feb0d72949237325eba791bc0.jpg";